import { useQueryClient } from '@tanstack/react-query';
export function createTaskRepository(config) {
    const { repository, client } = config;
    function getFindKey() {
        return ['platform', 'task', 'find'];
    }
    function getLookupKey(props) {
        return ['platform', 'task', 'lookup', props];
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getFindKey(),
                async queryFn() {
                    const response = await client.user.taskList({
                        xWorkspaceId: context.workspace.id,
                    });
                    return response.data.data;
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getLookupKey(props),
                async queryFn() {
                    const response = await client.user.taskRetrieve({
                        xWorkspaceId: context.workspace.id,
                        taskId: props.taskId,
                    });
                    return response.data;
                },
            });
            return query;
        },
        useCreate(context) {
            const queryClient = useQueryClient();
            return repository.useMutation(context, {
                async mutationFn(props) {
                    const response = await client.user.taskCreate({
                        xWorkspaceId: context.workspace.id,
                        taskCreatePayload: props,
                    });
                    return response.data;
                },
                async onSuccess(data) {
                    await queryClient.refetchQueries({ queryKey: getFindKey() });
                },
            });
        },
    };
}
//# sourceMappingURL=taskRepository.js.map